export default __webpack_public_path__ + "static/zone-dfd84b07a3249d15c314da801b7fd1e2.png";